import { render, staticRenderFns } from "./upload-provider-data.vue?vue&type=template&id=45f26447"
import script from "./upload-provider-data.vue?vue&type=script&lang=js"
export * from "./upload-provider-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports